import { useEffect } from 'react';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { Providers } from './providers';
import { AppRouter } from './router';
import { AuthProvider } from '../hooks/useAuth';

/**
 * Компонент для обработки startapp параметра (deep linking)
 * Telegram передаёт startapp=deal_123 — перенаправляем на /deal/123
 */
function DeepLinkHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const tgWebApp = (window as any).Telegram?.WebApp;
      const startParam = tgWebApp?.initDataUnsafe?.start_param;

      if (startParam) {
        // Формат: deal_123
        const match = startParam.match(/^deal_(\d+)$/);
        if (match) {
          navigate(`/deal/${match[1]}`, { replace: true });
        }
      }
    } catch {
      // Вне Telegram — игнорируем
    }
  }, [navigate]);

  return null;
}

/**
 * Корневой компонент приложения
 */
export function App() {
  return (
    <Providers>
      <BrowserRouter>
        <AuthProvider>
          <DeepLinkHandler />
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </Providers>
  );
}
